export const MAX_RETAINED_BACKUPS = 5;
export const RESTORE_CONFIRM_PHRASE = 'RESTORE';

export const DATABASE_BACKUP_HELP = {
  title: 'Database backups',
  subtitle: 'Keep up to five restore points. Upload a pg_dump file or snapshot the live database, then roll back if needed.',
  warn: 'Restore replaces the entire current database. A safety snapshot is taken first. Type RESTORE to confirm.',
};

export function isValidRestoreConfirm(value) {
  return String(value || '').trim().toUpperCase() === RESTORE_CONFIRM_PHRASE;
}

export function formatBackupSize(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
